/**
 * Client-side AppKit stub
 *
 * This module is imported ONLY on the client (in __root.tsx).
 * It synchronously sets up a stub AppKit instance before any React code runs,
 * preventing "Please call createAppKit before using hook" errors during hydration.
 *
 * The stub will be replaced by the real AppKit instance when App.jsx initializes.
 */

import * as appKitModule from '@reown/appkit/react';

// Debug: log to verify stub runs
console.log('[AppKit Stub] Setting up stub on client', window.location.href);

// Comprehensive stub that mimics initial AppKit state
appKitModule.getAppKit({
  // Core methods
  open: async () => {},
  close: async () => {},
  switchNetwork: async () => {},

  // Theme
  getThemeMode: () => 'light',
  getThemeVariables: () => ({}),
  setThemeMode: () => {},
  setThemeVariables: () => {},
  subscribeTheme: () => () => {},

  // Wallet info
  getWalletInfo: () => ({}),
  subscribeWalletInfo: () => () => {},

  // State - return initial disconnected state to match client before init
  getState: () => ({
    isConnected: false,
    address: null,
    chainId: null,
    wallet: null,
    walletType: null,
    walletConnectUri: null,
  }),

  getRemoteFeatures: () => ({}),

  // Subscriptions
  subscribeState: () => () => {},
  subscribeRemoteFeatures: () => () => {},
  subscribeEvents: () => () => {},

  // Events
  getEvent: () => ({}),
});

console.log('[AppKit Stub] Stub setup complete');